import React, { useEffect, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const Notificational = ({ setCount }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ Fetch notifications on component mount
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // 🔹 include token if required
        const response = await fetch(`${API_BASE_URL}/user/get-users-notification`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            filters: {},
            page: 1,
            limit: 30,
          }),
        });

        const data = await response.json();
        if (response.ok && data.success) {
          setNotifications(data.result.notifications || []);
          setCount(data.result.total || 0);   // 👈 update parent

        } else {
          console.error("Failed to fetch notifications:", data);
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
      setLoading(false);
    };

    fetchNotifications();
  }, []);

  // ✅ Handle redirect based on notification.key
  const handleRedirect = (notification) => {
    switch (notification.key) {
      case "postKey":
      case "postLikeKey":
      case "postCommentKey":
        navigate(`/post/${notification.notification_id}`);
        break;

      case "commentLikeKey":
      case "commentReplyKey":
        navigate(`/post/${notification.notification_id}#comments`);
        break;

      case "friendKey":
        navigate(`/profilefollowers`);
        break;

      case "storyKey":
      case "storyLikeKey":
      case "storyCommentKey":
        navigate(`/story/${notification.notification_id}`);
        break;

      case "groupKey":
        navigate(`/groupsfamily`);
        break;

      case "donationKey":
        navigate(`/donation/${notification.notification_id}`);
        break;

      default:
        console.log("No redirect for key:", notification.key);
        break;
    }
  };

  return (
    <div className="w-[100%] border">
      <div>
        <div className="flex items-center shadow-lg  bg-white justify-between px-4 py-2 border-b dark:border-gray-700">
          <h3 className="font-semibold text-gray-800 dark:text-white">
            Notifications{" "}
            <span className="text-xs  bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full border">
              {notifications.length}
            </span>
          </h3>
          <div className="flex gap-1 text-center">
            <a
              href="/Notification"
              className="text-sm text-red-600 font-semibold"
            >
              View All
            </a>
            <BsThreeDotsVertical />
          </div>
        </div>
        <div>
          {/* Notifications List */}
          <div>
            {loading ? (
              <p className="p-4 text-gray-500">Loading...</p>
            ) : notifications.length > 0 ? (
              <div className="divide-y divide-gray-200 text-[12px] dark:divide-gray-700">
                {notifications.map((item) => {
                  const isUnread = item.is_read === false || !item.read_at;

                  return (
                    <div
                      key={item.id}
                      onClick={() => handleRedirect(item)}
                      className={`py-2 px-3 flex gap-2 cursor-pointer transition
              ${isUnread
                          ? "bg-green-50 hover:bg-green-100 dark:bg-gray-800 dark:hover:bg-gray-700"
                          : "hover:bg-gray-50 dark:hover:bg-gray-700"
                        }
                    `}
                    >
                      {/* Profile Image */}
                      <div className="relative">
                        <img
                          src={item.profile_image || "/image/profilepic.png"}
                          alt="profile"
                          className="w-[30px] h-[30px] rounded-full mt-1"
                        />

                        {/* Unread dot */}
                        {isUnread && (
                          <span className="absolute top-0 right-0 w-2 h-2 bg-green-500 rounded-full" />
                        )}
                      </div>

                      {/* Notification Details */}
                      <div>
                        <p
                          className={`text-sm ${isUnread
                            ? "font-bold text-gray-900 dark:text-white"
                            : "font-semibold text-gray-700 dark:text-gray-300"
                            }`}
                        >
                          {item.title}
                        </p>

                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          {item.body || item.description}
                        </p>

                        <p className="text-xs text-gray-400 mt-1">
                          {new Date(item.created_at).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="p-4 text-gray-500">No notifications found</p>
            )}
          </div>

        </div>
      </div>
    </div>

  );
};

export default Notificational;
